<!-- 
    INCLUSAO E ALTERACAO DE TEMPLATES DE EMAIL
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import Vue from 'vue';
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
    },
    
    components: {
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            templemail: {...this.$store.getters.getEntities.templemail},
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

    },

    methods: {
        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else {
                    this.apiTemplate(this.templemail, this.templemail.codtempl, this.callBackPost)
                }
            })
        },

        callBackPost (template) {
            this.closeForm(template)
        },

        closeForm (template) {
            this.$emit('closeform', template)
        },

        async loadData () {
            await this.$store.dispatch('loadTemplEmail', { id: this.index } )
            if (this.$store.getters.getTemplEmail) {
                this.templemail = {...this.$store.getters.getTemplEmail}
            }
        },

    },

    watch: {
        nome: function () {
            // console.log(this.nome)
        }

    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            if (this.$refs.descricao) {
               this.$refs.descricao.focus()
            }
        })
    },

    created () {
        if (this.index) 
          this.loadData()
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <h4 class="def-title" v-if="templemail.codtempl">Alterar Template</h4>
                <h4 v-else class="def-title">Novo Template</h4>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row align-items-center">
                    <form-field ref="descricao" v-model="templemail.descricao" type="text" col="12" :metadata="metadata.templemail.descricao" ></form-field>

                    <div class="col-12">
                        <input-switch type="success" label="Template Publico" v-model="templemail.publico" value-checked="S" value-unchecked="N" :metadata="metadata.part.cliente"></input-switch>
                    </div>

                    <form-field v-model="templemail.subject" type="text" col="12" :metadata="metadata.templemail.subject" ></form-field>

                    <div class="col-12">
                        <wysiwyg v-model="templemail.body_content" />
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <v-button label="Cancelar" class="float-right" icon="fa-arrow-left" @click="closeForm"></v-button>
                <v-button label="Salvar" class="float-right" :nb-btdef="true" @click="handleSalvar"></v-button>
            </div>

        </div>

    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/template-email-form.vue